"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkInfo = void 0;
exports.sdkInfo = {
    host: 'npmjs.com',
    version: '0.4.10',
    name: '@kentico/kontent-management'
};
//# sourceMappingURL=sdk-info.generated.js.map